module.exports = __webpack_public_path__ + "img/icon-lottery-yellow.0691195b.svg";